import request from '@/utils/request';

/**
 * AI 写作管理相关 API
 */

/**
 * 分页查询已添加的提示词列表
 * @param {number} pageNum - 页码
 * @param {number} pageSize - 每页条数
 * @returns {Promise}
 */
export function getAiDefaultPromptList(pageNum = 1, pageSize = 10) {
  return request({
    url: '/manager/default-prompt/page',
    method: 'post',
    data: { pageNum, pageSize }
  });
}

/**
 * 获取可新增的类型下拉选项
 * @returns {Promise}
 */
export function getAiDefaultPromptAvailableKinds() {
  return request({
    url: '/manager/default-prompt/available-kinds',
    method: 'post',
    data: {}
  });
}

/**
 * 新增提示词
 * @param {Object} data - 请求参数
 * @param {number} data.kindCode - 类型编码
 * @param {string} data.prompt - 提示词内容
 * @param {number} [data.status] - 状态：0-禁用 1-启用
 * @param {number} [data.modelId] - 默认模型ID
 * @returns {Promise}
 */
export function createAiDefaultPrompt(data) {
  return request({
    url: '/manager/default-prompt/create',
    method: 'post',
    data: {
      kindCode: data.kindCode,
      prompt: data.prompt,
      status: data.status !== undefined ? data.status : undefined,
      modelId: data.modelId || undefined
    }
  });
}

/**
 * 查询单条详情
 * @param {number} kindCode - 类型编码
 * @returns {Promise}
 */
export function getAiDefaultPromptDetail(kindCode) {
  return request({
    url: '/manager/default-prompt/detail',
    method: 'post',
    data: { kindCode }
  });
}

/**
 * 修改提示词内容
 * @param {Object} data - 请求参数
 * @param {number} data.kindCode - 类型编码
 * @param {string} data.prompt - 提示词内容
 * @param {number} [data.status] - 状态：0-禁用 1-启用
 * @param {number} [data.modelId] - 默认模型ID
 * @returns {Promise}
 */
export function updateAiDefaultPrompt(data) {
  return request({
    url: '/manager/default-prompt/update',
    method: 'post',
    data: {
      kindCode: data.kindCode,
      prompt: data.prompt,
      status: data.status !== undefined ? data.status : undefined,
      modelId: data.modelId !== undefined && data.modelId !== null ? data.modelId : undefined
    }
  });
}

/**
 * 软删除
 * @param {number} kindCode - 类型编码
 * @returns {Promise}
 */
export function deleteAiDefaultPrompt(kindCode) {
  return request({
    url: '/manager/default-prompt/delete',
    method: 'post',
    data: { kindCode }
  });
}

/**
 * 恢复已删除
 * @param {number} kindCode - 类型编码
 * @returns {Promise}
 */
export function restoreAiDefaultPrompt(kindCode) {
  return request({
    url: '/manager/default-prompt/restore',
    method: 'post',
    data: { kindCode }
  });
}

/**
 * 查看变更历史
 * @param {number} kindCode - 类型编码
 * @param {number} pageNum - 页码
 * @param {number} pageSize - 每页条数
 * @returns {Promise}
 */
export function getAiDefaultPromptHistoryList(kindCode, pageNum = 1, pageSize = 10) {
  return request({
    url: '/manager/default-prompt/history-page',
    method: 'post',
    data: { kindCode, pageNum, pageSize }
  });
}
